module.exports = __webpack_public_path__ + "static/stars-7d4f57c02ead83c69d4d7dc8a510d561.gif";